module.exports = __webpack_public_path__ + "img/full1-min.c9f3d155.png";